import React from "react";
import { default as Plotly } from "plotly.js-basic-dist-min";
import createPlotlyComponent from "react-plotly.js/factory";
import Card from "../../components/Card/Card";
import { Col, Row, ControlLabel } from "react-bootstrap";
import Select from "react-select";
import { apiV2 } from "../../services/api";
import ClipLoader from "react-spinners/ClipLoader";
import { months, monthLabels } from "../../variables/Variables";
import { CSVLink } from "react-csv";
import Button from "../../components/CustomButton/CustomButton.jsx";
import moment from "moment";

const { stats: statsApi } = apiV2;
const Datetime = require("react-datetime");
const Plot = createPlotlyComponent(Plotly);

class Statistics extends React.Component {
  constructor(props) {
    super(props);

    var date = new Date();
    var month = date.getMonth() + 1;
    var monthName = date.toLocaleString("default", { month: "long" });
    var year = date.getFullYear();

    this.state = {
      callsByMonth: [],
      callsByMonthStartDate: moment(date).startOf("year"),
      callsByMonthEndDate: moment(date).endOf("year"),
      referralsByMonth: [],
      callsByState: [],
      shiftsByCallTaker: [],
      callsByCallTaker: [],
      referrals: { yes: 0, no: 0 },
      referralsByReason: [],
      year: { value: year, label: year },
      callsByStateMonth: { value: month, label: monthName },
      callsByStateStartDate: moment(date).add(-30, "days"),
      callsByStateEndDate: moment(date),
      shiftsByCallTakerMonth: { value: month, label: monthName },
      callsByCallTakerMonth: { value: month, label: monthName },
      callsByCallTakerStartDate: moment(date).add(-30, "days"),
      callsByCallTakerEndDate: moment(date),
      callsByMonthLoading: false,
      referralsByMonthLoading: false,
      callsByStateLoading: false,
      shiftsByCallTakerLoading: false,
      callsByCallTakerLoading: false,
      referralsLoading: false,
      referralsByReasonLoading: false,
      shiftsByCallTakerStartDate: moment().add(-30, "days"),
      shiftsByCallTakerEndDate: moment(),
      referralsStartDate: moment().add(-30, "days"),
      referralsEndDate: moment(),
      referralsByReasonStartDate: moment().add(-30, "days"),
      referralsByReasonEndDate: moment(),

      referralsByMonthStartDate: moment().add(-30, "days"),
      referralsByMonthEndDate: moment(),
    };

    this.updateYear = this.updateYear.bind(this);
  }

  unpack(rows, key) {
    return rows.map((row) => {
      return row[key];
    });
  }

  componentDidMount() {
    this.updateAllCharts(this.state);
  }

  updateAllCharts(oldState) {
    this.getCallsByMonth(oldState);
    this.getCallsByState(oldState);
    this.getShiftsByCallTakerDateRange(oldState);
    this.getCallsByCallTaker(oldState);
    this.getReferralsByMonth(oldState);
    this.getReferralsDateRange(oldState);
    this.getReferralsByReasonDateRange(oldState);
  }

  // changing the year updates all charts
  // whereas changing months is chart by chart
  updateYear(evt) {
    var oldState = this.state;
    oldState.year = evt;
    oldState.callsByMonth = [];
    oldState.referralsByMonth = [];
    oldState.callsByState = [];
    oldState.shiftsByCallTaker = [];
    oldState.callsByCallTaker = [];
    oldState.referrals = [];
    oldState.referralsByReason = [];
    oldState.callsByMonthLoading = true;
    oldState.referralsByMonthLoading = true;
    oldState.callsByStateLoading = true;
    oldState.shiftsByCallTakerLoading = true;
    oldState.callsByCallTakerLoading = true;
    oldState.referralsLoading = true;

    const { value: newYear } = evt;

    // Calls per Month
    [oldState.callsByMonthStartDate, oldState.callsByMonthEndDate] =
      this.setYearRange(newYear);

    // Calls by State
    [oldState.callsByStateStartDate, oldState.callsByStateEndDate] =
      this.setMonthRange(oldState.callsByStateMonth.value, newYear);

    // Calls by Call Taker
    [oldState.callsByCallTakerStartDate, oldState.callsByCallTakerEndDate] =
      this.setMonthRange(oldState.callsByCallTakerMonth.value, newYear);

    // Shifts by Call Taker
    [oldState.shiftsByCallTakerStartDate, oldState.shiftsByCallTakerEndDate] = [
      this.setYear(oldState.shiftsByCallTakerStartDate, newYear),
      this.setYear(oldState.shiftsByCallTakerEndDate, newYear),
    ];

    // Referrals by Month
    [oldState.referralsByMonthStartDate, oldState.referralsByMonthEndDate] = [
      this.setYear(oldState.referralsByMonthStartDate, newYear),
      this.setYear(oldState.referralsByMonthEndDate, newYear),
    ];

    //Referrals Frequency
    [oldState.referralsStartDate, oldState.referralsEndDate] = [
      this.setYear(oldState.referralsStartDate, newYear),
      this.setYear(oldState.referralsEndDate, newYear),
    ];

    //Referrals by Reason
    [oldState.referralsByReasonStartDate, oldState.referralsByReasonEndDate] = [
      this.setYear(oldState.referralsByReasonStartDate, newYear),
      this.setYear(oldState.referralsByReasonEndDate, newYear),
    ];

    this.setState(oldState);

    this.updateAllCharts(oldState);
  }

  formatDate(dt) {
    return moment(dt).format("YYYY-MM-DD");
  }

  setMonthRange(month, year) {
    return [
      moment()
        .month(month - 1)
        .year(year)
        .startOf("month"),
      moment()
        .month(month - 1)
        .year(year)
        .endOf("month"),
    ];
  }

  setYear(date, year) {
    return moment(date).year(year);
  }

  setYearRange(year) {
    return [
      moment().year(year).startOf("year"),
      moment().year(year).endOf("year"),
    ];
  }

  getCallsByMonth(oldState) {
    if (!oldState) {
      oldState = this.state;
    }

    const [from, to] = [
      this.formatDate(oldState.callsByMonthStartDate),
      this.formatDate(oldState.callsByMonthEndDate),
    ];
    statsApi.getEntriesPerMonth(from, to).then((res) => {
      this.setState({
        callsByMonthLoading: false,
        callsByMonth: Object.values(res),
      });
    });
  }
  getCallsByState(oldState) {
    if (!oldState) {
      oldState = this.state;
    }

    const [from, to] = [
      this.formatDate(oldState.callsByStateStartDate),
      this.formatDate(oldState.callsByStateEndDate),
    ];
    statsApi.getEntriesByStateProvince(from, to).then((res) => {
      const formattedRes = Object.values(res).flatMap((country) =>
        Object.entries(country).map(([province_state, count]) => ({
          province_state,
          count,
        }))
      );
      this.setState({
        callsByStateLoading: false,
        callsByState: formattedRes,
      });
    });
  }

  getShiftsByCallTakerDateRange(oldState) {
    if (!oldState) {
      oldState = this.state;
    }
    const [from, to] = [
      this.formatDate(oldState.shiftsByCallTakerStartDate),
      this.formatDate(oldState.shiftsByCallTakerEndDate),
    ];
    statsApi.getShiftsPerCallTaker(from, to).then((res) => {
      this.setState({
        shiftsByCallTakerLoading: false,
        shiftsByCallTaker: res,
      });
    });
  }
  getCallsByCallTaker(oldState) {
    if (!oldState) {
      oldState = this.state;
    }

    const [from, to] = [
      this.formatDate(oldState.callsByCallTakerStartDate),
      this.formatDate(oldState.callsByCallTakerEndDate),
    ];
    statsApi.getEntriesPerCallTaker(from, to).then((res) => {
      const formattedRes = res.map(
        ({ callTaker: call_taker_id, entriesSubmitted: count }) => ({
          call_taker_id,
          count,
        })
      );
      this.setState({
        callsByCallTakerLoading: false,
        callsByCallTaker: formattedRes,
      });
    });
  }
  getReferralsByMonth(oldState) {
    if (!oldState) {
      oldState = this.state;
    }

    const [from, to] = [
      this.formatDate(oldState.referralsByMonthStartDate),
      this.formatDate(oldState.referralsByMonthEndDate),
    ];

    statsApi.getReferralsPerMonth(from, to).then((res) => {
      this.setState({
        referralsByMonthLoading: false,
        referralsByMonth: Object.values(res),
      });
    });
  }
  getReferralsDateRange(oldState) {
    if (!oldState) {
      oldState = this.state;
    }

    const [from, to] = [
      this.formatDate(oldState.referralsStartDate),
      this.formatDate(oldState.referralsEndDate),
    ];

    statsApi.getReferralsFrequency(from, to).then((res) => {
      const formattedRes = { yes: res.referred, no: res.nonReferred };
      this.setState({
        referralsLoading: false,
        referrals: formattedRes,
      });
    });
  }
  getReferralsByReasonDateRange(oldState) {
    if (!oldState) {
      oldState = this.state;
    }

    const [from, to] = [
      this.formatDate(oldState.referralsByReasonStartDate),
      this.formatDate(oldState.referralsByReasonEndDate),
    ];

    statsApi.getEntriesPerCoplineReferrals(from, to).then((res) => {
      const formattedRes = res.map(({ coplineReferral: reason, count }) => ({
        reason,
        count,
      }));
      this.setState({
        referralsByReasonLoading: false,
        referralsByReason: formattedRes,
      });
    });
  }

  postitiveCountShiftTakers() {
    return this.state.shiftsByCallTaker.filter((x) => {
      return x.count !== 0;
    });
  }

  render() {
    var today = new Date();
    var date =
      "-" +
      today.getFullYear() +
      "-" +
      (today.getMonth() + 1) +
      "-" +
      today.getDate();
    // show year options for 2020 to this year
    var yearRange = [];
    for (var i = 2020; i <= today.getFullYear(); i++) {
      yearRange.push(i);
    }
    return (
      <div className="main-content">
        <Card
          content={
            <Row>
              <Row>
                {!this.state.callsByMonthLoading && (
                  <Col xs={12} sm={6}>
                    <Row>
                      <Col
                        xs={10}
                        sm={6}
                        style={{
                          fontSize: 26,
                          textAlign: "center",
                          marginLeft: 60,
                          marginBottom: 20,
                        }}
                      >
                        <ControlLabel>Entries by Month</ControlLabel>
                        {this.state.callsByMonth.length > 0 && (
                          <CSVLink
                            filename={`entries_by_month${date}.csv`}
                            data={this.state.callsByMonth.map(
                              (count, index) => {
                                return { month: months[index], count: count };
                              }
                            )}
                          >
                            <Button
                              onClick={() => {}}
                              bsStyle="warning"
                              simple
                              icon
                            >
                              <i
                                className="pe-7s-download action-icon"
                                style={{ color: "black" }}
                              />
                            </Button>
                          </CSVLink>
                        )}
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={10} sm={3} style={{ margin: 15 }}>
                        <ControlLabel>Select a Year</ControlLabel>
                        <Select
                          options={yearRange.map((year) => {
                            return { value: year, label: year };
                          })}
                          value={this.state.year}
                          name="yearSelect"
                          onChange={this.updateYear}
                        />
                      </Col>
                    </Row>
                    <Plot
                      style={{ width: "100%", height: "100%" }}
                      config={{ displayModeBar: false }}
                      data={[
                        {
                          type: "bar",
                          textposition: "auto",
                          x: months,
                          y: this.state.callsByMonth,
                        },
                      ]}
                      layout={{ autosize: true, title: "" }}
                    />
                  </Col>
                )}
                {this.state.callsByMonthLoading && (
                  <Col>
                    <div style={{ margin: 22 }}>Loading...</div>
                    <Col xs={12} sm={6}>
                      <ClipLoader loading size={50} color="grey" />
                    </Col>
                  </Col>
                )}
                {!this.state.callsByStateLoading && (
                  <Col xs={12} sm={6}>
                    <Row>
                      <Col
                        xs={10}
                        sm={10}
                        style={{
                          fontSize: 26,
                          textAlign: "center",
                          marginBottom: 20,
                        }}
                      >
                        <ControlLabel>Entries by State/Province</ControlLabel>
                        {this.state.callsByState.length > 0 && (
                          <CSVLink
                            filename={`entries_by_state_province${date}.csv`}
                            data={this.state.callsByState}
                          >
                            <Button
                              onClick={() => {}}
                              bsStyle="warning"
                              simple
                              icon
                            >
                              <i
                                className="pe-7s-download action-icon"
                                style={{ color: "black" }}
                              />
                            </Button>
                          </CSVLink>
                        )}
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={10} sm={4} style={{ marginLeft: 60 }}>
                        <ControlLabel>Select a Month</ControlLabel>
                        <Select
                          options={monthLabels}
                          value={this.state.callsByStateMonth}
                          name="callsByStateMonth"
                          onChange={(opt) =>
                            this.setState(
                              {
                                callsByState: [],
                                callsByStateMonth: opt,
                                callsByStateLoading: true,
                              },
                              () => {
                                this.getCallsByState();
                              }
                            )
                          }
                        />
                      </Col>
                    </Row>
                    <Plot
                      style={{ width: "100%", height: "100%" }}
                      config={{ displayModeBar: false }}
                      data={[
                        {
                          type: "bar",
                          textposition: "auto",
                          x: this.state.callsByState.map((c) => {
                            if (c.province_state !== "UNKNOWN") {
                              return c.province_state;
                            }
                            return null;
                          }),
                          y: this.state.callsByState.map((c) => {
                            if (c.province_state !== "UNKNOWN") {
                              return c.count;
                            }
                            return null;
                          }),
                        },
                      ]}
                      layout={{ autosize: true, title: "" }}
                    />
                    {/* <GeoPlot data={[{
                    type: 'choropleth',
                    locationmode: 'USA-states',
                    locations: this.unpack(stateCalls, 'Postal'),
                    z: this.unpack(stateCalls, 'Calls'),
                    text: this.unpack(stateCalls, 'State'),
                    autocolorscale: true
                  }]} layout={layout} /> */}
                  </Col>
                )}
                {this.state.callsByStateLoading && (
                  <Col>
                    <div style={{ margin: 22 }}>Loading...</div>
                    <Col xs={12} sm={6}>
                      <ClipLoader loading size={50} color="grey" />
                    </Col>
                  </Col>
                )}
              </Row>
              <Row>
                {!this.state.callsByCallTakerLoading && (
                  <Col xs={12} sm={6}>
                    <Row>
                      <Col
                        xs={10}
                        sm={10}
                        style={{
                          fontSize: 26,
                          textAlign: "center",
                          marginBottom: 20,
                        }}
                      >
                        <ControlLabel>Entries by Call Taker</ControlLabel>
                        {this.state.callsByCallTaker.length > 0 && (
                          <CSVLink
                            filename={`entries_by_call_taker${date}.csv`}
                            data={this.state.callsByCallTaker}
                          >
                            <Button
                              onClick={() => {}}
                              bsStyle="warning"
                              simple
                              icon
                            >
                              <i
                                className="pe-7s-download action-icon"
                                style={{ color: "black" }}
                              />
                            </Button>
                          </CSVLink>
                        )}
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={10} sm={4} style={{ marginLeft: 60 }}>
                        <ControlLabel>Select a Month</ControlLabel>
                        <Select
                          options={monthLabels}
                          value={this.state.callsByCallTakerMonth}
                          name="callsByCallTakerMonth"
                          onChange={(opt) =>
                            this.setState(
                              {
                                callsByCallTaker: [],
                                callsByCallTakerMonth: opt,
                                callsByCallTakerLoading: true,
                              },
                              () => {
                                this.getCallsByCallTaker();
                              }
                            )
                          }
                        />
                      </Col>
                    </Row>
                    <Plot
                      style={{ width: "100%", height: "100%" }}
                      config={{ displayModeBar: false }}
                      data={[
                        {
                          type: "bar",
                          textposition: "auto",
                          x: this.state.callsByCallTaker.map(
                            (c) => c.call_taker_id
                          ),
                          y: this.state.callsByCallTaker.map((c) => c.count),
                        },
                      ]}
                      layout={{ autosize: true, title: "" }}
                    />
                  </Col>
                )}
                {this.state.callsByCallTakerLoading && (
                  <Col>
                    <div style={{ margin: 22 }}>Loading...</div>
                    <Col xs={12} sm={6}>
                      <ClipLoader loading size={50} color="grey" />
                    </Col>
                  </Col>
                )}
                {!this.state.shiftsByCallTakerLoading && (
                  <Col xs={12} sm={6}>
                    <Row>
                      <Col
                        xs={10}
                        sm={10}
                        style={{
                          fontSize: 26,
                          textAlign: "center",
                          marginBottom: 20,
                        }}
                      >
                        <ControlLabel>Shifts by Call Taker</ControlLabel>
                        {this.state.shiftsByCallTaker.length > 0 && (
                          <CSVLink
                            filename={`shifts_by_call_taker${date}.csv`}
                            data={this.state.shiftsByCallTaker.sort((a, b) => {
                              return a.shiftsTaken - b.shiftsTaken;
                            })}
                          >
                            <Button
                              onClick={() => {}}
                              bsStyle="warning"
                              simple
                              icon
                            >
                              <i
                                className="pe-7s-download action-icon"
                                style={{ color: "black" }}
                              />
                            </Button>
                          </CSVLink>
                        )}
                      </Col>
                    </Row>
                    <Row style={{ paddingLeft: "15px" }}>
                      <Col xs={12} sm={5}>
                        <p>From Date: </p>
                        <Datetime
                          id="start-date-filter"
                          name="shiftsByCallTakerStartDate"
                          value={this.state.shiftsByCallTakerStartDate}
                          timeFormat={false}
                          onChange={(opt) =>
                            this.setState(
                              {
                                shiftsByCallTaker: [],
                                shiftsByCallTakerStartDate: opt,
                                shiftsByCallTakerLoading: true,
                              },
                              () => {
                                this.getShiftsByCallTakerDateRange();
                              }
                            )
                          }
                        />
                      </Col>
                      <Col xs={12} sm={5}>
                        <p>To Date: </p>
                        <Datetime
                          id="end-date-filter"
                          name="shiftsByCallTakerEndDate"
                          value={this.state.shiftsByCallTakerEndDate}
                          timeFormat={false}
                          onChange={(opt) =>
                            this.setState(
                              {
                                shiftsByCallTaker: [],
                                shiftsByCallTakerEndDate: opt,
                                shiftsByCallTakerLoading: true,
                              },
                              () => {
                                this.getShiftsByCallTakerDateRange();
                              }
                            )
                          }
                        />
                      </Col>
                    </Row>
                    {/* <Row>
                    <Col xs={10} sm={4} style={{ marginLeft: 60 }}>
                      <ControlLabel>Select a Month</ControlLabel>
                      <Select
                        options={monthLabels}
                        value={this.state.shiftsByCallTakerMonth}
                        name='shiftsByCallTakerMonth'
                        onChange={opt => this.setState({
                            shiftsByCallTaker: [],
                            shiftsByCallTakerMonth: opt,
                            shiftsByCallTakerLoading: true
                          }, () => {
                            this.getShiftsByCallTaker()
                          })
                        }
                      />
                    </Col>
                  </Row> */}
                    <Plot
                      style={{ width: "100%", height: "100%" }}
                      config={{ displayModeBar: false }}
                      data={[
                        {
                          type: "bar",
                          textposition: "auto",
                          x: this.postitiveCountShiftTakers().map(
                            (c) => c.callTaker
                          ),
                          y: this.postitiveCountShiftTakers().map(
                            (c) => c.shiftsTaken
                          ),
                        },
                      ]}
                      layout={{ autosize: true, title: "" }}
                    />
                  </Col>
                )}
                {this.state.shiftsByCallTakerLoading && (
                  <Col>
                    <div style={{ margin: 22 }}>Loading...</div>
                    <Col xs={12} sm={6}>
                      <ClipLoader loading size={50} color="grey" />
                    </Col>
                  </Col>
                )}
              </Row>
              <Row>
                {!this.state.referralsByMonthLoading && (
                  <Col xs={12} sm={6}>
                    <Row>
                      <Col
                        xs={10}
                        sm={10}
                        style={{
                          fontSize: 26,
                          textAlign: "center",
                          marginBottom: 20,
                        }}
                      >
                        <ControlLabel>Referrals by Month</ControlLabel>
                        {this.state.referralsByMonth.length > 0 && (
                          <CSVLink
                            filename={`referrals_by_month${date}.csv`}
                            data={this.state.referralsByMonth.map(
                              (count, index) => {
                                return { month: months[index], count: count };
                              }
                            )}
                          >
                            <Button
                              onClick={() => {}}
                              bsStyle="warning"
                              simple
                              icon
                            >
                              <i
                                className="pe-7s-download action-icon"
                                style={{ color: "black" }}
                              />
                            </Button>
                          </CSVLink>
                        )}
                      </Col>
                    </Row>
                    <Row style={{ paddingLeft: "15px" }}>
                      <Col xs={12} sm={5}>
                        <p>From Date: </p>
                        <Datetime
                          id="start-date-filter"
                          name="referralsByMonthStartDate"
                          value={this.state.referralsByMonthStartDate}
                          timeFormat={false}
                          onChange={(opt) =>
                            this.setState(
                              {
                                referralsByMonth: [],
                                referralsByMonthStartDate: opt,
                                referralsByMonthLoading: true,
                              },
                              () => {
                                this.getReferralsByMonth();
                              }
                            )
                          }
                        />
                      </Col>
                      <Col xs={12} sm={5}>
                        <p>To Date: </p>
                        <Datetime
                          id="end-date-filter"
                          name="referralsByMonthEndDate"
                          value={this.state.referralsByMonthEndDate}
                          timeFormat={false}
                          onChange={(opt) =>
                            this.setState(
                              {
                                referralsByMonth: [],
                                referralsByMonthEndDate: opt,
                                referralsByMonthLoading: true,
                              },
                              () => {
                                this.getReferralsByMonth();
                              }
                            )
                          }
                        />
                      </Col>
                    </Row>
                    <Plot
                      style={{ width: "100%", height: "100%" }}
                      config={{ displayModeBar: false }}
                      data={[
                        {
                          type: "bar",
                          textposition: "auto",
                          x: months,
                          y: this.state.referralsByMonth,
                        },
                      ]}
                      layout={{ autosize: true, title: "" }}
                    />
                  </Col>
                )}
                {this.state.referralsByMonthLoading && (
                  <Col>
                    <div style={{ margin: 22 }}>Loading...</div>
                    <Col xs={12} sm={6}>
                      <ClipLoader loading size={50} color="grey" />
                    </Col>
                  </Col>
                )}
                {/* REFERRALS */}
                {!this.state.referralsLoading && (
                  <Col xs={12} sm={6}>
                    <Row>
                      <Col
                        xs={10}
                        sm={10}
                        style={{
                          fontSize: 26,
                          textAlign: "center",
                          marginBottom: 20,
                        }}
                      >
                        <ControlLabel>Referrals Frequency</ControlLabel>
                        {/* {this.state.referrals !== null &&
                            <CSVLink filename={`referrals${date}.csv`} data={this.state.referrals}>
                              <Button
                                onClick={() => {}}
                                bsStyle="warning"
                                simple icon>
                                <i className="pe-7s-download action-icon" style={{ color: 'black' }} />
                              </Button>
                            </CSVLink>
                          } */}
                      </Col>
                    </Row>
                    <Row style={{ paddingLeft: "15px" }}>
                      <Col xs={12} sm={5}>
                        <p>From Date: </p>
                        <Datetime
                          id="referrals-start-date-filter"
                          name="referralsStartDate"
                          value={this.state.referralsStartDate}
                          timeFormat={false}
                          onChange={(opt) =>
                            this.setState(
                              {
                                referrals: [],
                                referralsStartDate: opt,
                                referralsLoading: true,
                              },
                              () => {
                                this.getReferralsDateRange();
                              }
                            )
                          }
                        />
                      </Col>
                      <Col xs={12} sm={5}>
                        <p>To Date: </p>
                        <Datetime
                          id="referrals-end-date-filter"
                          name="referralsEndDate"
                          value={this.state.referralsEndDate}
                          timeFormat={false}
                          onChange={(opt) =>
                            this.setState(
                              {
                                referrals: [],
                                referralsEndDate: opt,
                                referralsLoading: true,
                              },
                              () => {
                                this.getReferralsDateRange();
                              }
                            )
                          }
                        />
                      </Col>
                    </Row>
                    <Plot
                      style={{ width: "100%", height: "100%" }}
                      config={{ displayModeBar: false }}
                      data={[
                        {
                          type: "bar",
                          textposition: "auto",
                          x: ["Referred", "Not Referred"],
                          y: [
                            this.state.referrals?.yes,
                            this.state.referrals?.no,
                          ],
                        },
                      ]}
                      layout={{ autosize: true, title: "" }}
                    />
                  </Col>
                )}
                {this.state.referralsLoading && (
                  <Col>
                    <div style={{ margin: 22 }}>Loading...</div>
                    <Col xs={12} sm={6}>
                      <ClipLoader loading size={50} color="grey" />
                    </Col>
                  </Col>
                )}
              </Row>
              <Row>
                {!this.state.referralsByReasonLoading && (
                  <Col xs={12} sm={6}>
                    <Row>
                      <Col
                        xs={10}
                        sm={10}
                        style={{
                          fontSize: 26,
                          textAlign: "center",
                          marginBottom: 20,
                        }}
                      >
                        <ControlLabel>Heard About CopLine</ControlLabel>
                        {this.state.referralsByMonth.length > 0 && (
                          <CSVLink
                            filename={`referrals_by_reason${date}.csv`}
                            data={this.state.referralsByReason.map(
                              (referral, index) => {
                                return {
                                  reason: referral.reason,
                                  count: referral.count,
                                };
                              }
                            )}
                          >
                            <Button
                              onClick={() => {}}
                              bsStyle="warning"
                              simple
                              icon
                            >
                              <i
                                className="pe-7s-download action-icon"
                                style={{ color: "black" }}
                              />
                            </Button>
                          </CSVLink>
                        )}
                      </Col>
                    </Row>
                    <Row style={{ paddingLeft: "15px" }}>
                      <Col xs={12} sm={5}>
                        <p>From Date: </p>
                        <Datetime
                          id="referral-reasons-start-date-filter"
                          name="referralsByReasonStartDate"
                          value={this.state.referralsByReasonStartDate}
                          timeFormat={false}
                          onChange={(opt) =>
                            this.setState(
                              {
                                referralsByReason: [],
                                referralsByReasonStartDate: opt,
                                referralsByReasonLoading: true,
                              },
                              () => {
                                this.getReferralsByReasonDateRange();
                              }
                            )
                          }
                        />
                      </Col>
                      <Col xs={12} sm={5}>
                        <p>To Date: </p>
                        <Datetime
                          id="referrals-by-reason-end-date-filter"
                          name="referralsByReasonEndDate"
                          value={this.state.referralsByReasonEndDate}
                          timeFormat={false}
                          onChange={(opt) =>
                            this.setState(
                              {
                                referralsByReason: [],
                                referralsByReasonEndDate: opt,
                                referralsByReasonLoading: true,
                              },
                              () => {
                                this.getReferralsByReasonDateRange();
                              }
                            )
                          }
                        />
                      </Col>
                    </Row>
                    <Plot
                      style={{ width: "100%", height: "100%" }}
                      config={{ displayModeBar: false }}
                      data={[
                        {
                          type: "bar",
                          textposition: "auto",
                          x: this.state.referralsByReason.map((r) => r.reason),
                          y: this.state.referralsByReason.map((r) => r.count),
                        },
                      ]}
                      layout={{ autosize: true, title: "" }}
                    />
                  </Col>
                )}
                {this.state.referralsByReasonLoading && (
                  <Col>
                    <div style={{ margin: 22 }}>Loading...</div>
                    <Col xs={12} sm={6}>
                      <ClipLoader loading size={50} color="grey" />
                    </Col>
                  </Col>
                )}
              </Row>
            </Row>
          }
        />
      </div>
    );
  }
}

export default Statistics;
